export const INTENT_TEMPLATE_TYPES = {
	DISCOVERED: 'DISCOVERED',
	SHARED: 'SHARED',
	STANDARD: 'STANDARD',
} as const;

export type IntentTemplateType = (typeof INTENT_TEMPLATE_TYPES)[keyof typeof INTENT_TEMPLATE_TYPES];

export type IntentTemplate = {
	readonly id?: string;
	readonly name?: string;
	readonly description?: string | null;
	readonly questions?: readonly string[];
	readonly type?: IntentTemplateType;
};
